import { render } from "./Paragraph.vue?vue&type=template&id=32f89ecc&ts=true"
import script from "./Paragraph.vue?vue&type=script&lang=ts"
export * from "./Paragraph.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__